import React, { useState, useEffect } from 'react';
import Button from 'jsx/elements/buttons/Button';
import Warning from 'jsx/elements/messages/Warning';
import {apiPostCall, isResultOk} from '../../components/special/apiCall';
import InputText from 'components/input/InputText';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TableEdit = (props) => {
  
  const setIsPageLoading = usePageLoadingContext();
  const setCheckErrorItems = useErrorContext();
  const params = new URLSearchParams(useLocation().search);
  const [isNew, setIsNew] = useState(true);
  const [data, setData] = useState({ tableTypeID : 0,
                                     tableID : 0,
                                     name : "",
                                     tableCode : "",
                                     typeID : null});

  const [messageBox, setMessageBox] = useState({ showMessageBox : false,
                                                 messageBoxText : "",
                                                 messageBoxType : "" })
  

  const loadFormData = async() => {
    setIsPageLoading(true);
    let isNew = params.get("new");
    let newData = {...data, tableTypeID : params.get("tabletypeid"), tableID : params.get("tableid")};
    if (!isNew && newData.tableID > 0){
      setIsNew(false);
      const tableRes = await apiPostCall(BASE_URL + '/admin/table', newData);
      if (isResultOk(tableRes, setCheckErrorItems)){
        setData(tableRes);
      }
    }
    else{
      data.tableTypeID = newData.tableTypeID;
    }
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {
    setIsPageLoading(true);
    if (validInput()){
      let requestResult = null;
      if (isNew) {
        requestResult = await apiPostCall(BASE_URL + '/admin/table/create', data);
      }
      else {
        requestResult = await apiPostCall(BASE_URL + '/admin/table/change', data);
      }
      if (isResultOk(requestResult, setCheckErrorItems)) {
        props.history.goBack();
      }
    }
    setIsPageLoading(false);
  }

  function onCancelClick() {
    props.history.goBack();
  }

  function validInput() {
    if (data.name === ""){
      triggerMessageBox("Vantar heiti", "alert");
      return false;
    }
    else if (data.tableCode === ""){
      triggerMessageBox("Vantar Kóða", "alert");
      return false;
    }
    return true;
  }

  function triggerMessageBox(text, type) {
      setMessageBox({ showMessageBox : true,
        messageBoxText : text,
        messageBoxType : type });
  }

  const centerFrameDiv = {
    margin: "0 auto",
    width:"500px"
  };

  return (
    <div style={centerFrameDiv}>
      <div className="grid tight collapse480">
          <div className="col s6of12">
              {isNew && <h1 className="text-red text-32">Nýskrá töflu</h1>}
              {!isNew && <h1 className="text-red text-32">Breyta töflu</h1>}
          </div>
      </div>
      <div className="table-wrap">
          <table className="table advanced hover">
              <colgroup>
                  <col />
                  <col />
              </colgroup>
              <tbody>
                  <tr>
                      <th className="text-left">Heiti</th>
                      <td className="no-padding">
                          <div className="form">
                            <InputText name="name" value={data.name} onChange={(value) => setData({...data, name : value})}/> 
                          </div>
                      </td>
                  </tr>

                  <tr>
                      <th className="text-left">Kóði</th>
                      <td className="no-padding">
                          <div className="form">
                            <InputText name="tablecode" value={data.tableCode} onChange={(value) => setData({...data, tableCode : value})}/>
                          </div>
                      </td>
                  </tr>

              </tbody>
          </table>
      </div>
      {messageBox.showMessageBox && <Warning messageHeader={messageBox.messageBoxText} onClose={() => setMessageBox({ ...messageBox, showMessageBox : false })} messageType={messageBox.messageBoxType}/>}
      <div className="grid collapse840">
        <div className="col s1of2">
          <Button text="Til baka" color="gray-light" onClick={onCancelClick}></Button>         
        </div>
        <div className="col s1of2 float-right text-right">
          <Button text="Vista" color="gray" iconright="true" onClick={onSaveClick}></Button>
        </div>
      </div>          
    </div>
  );
}

